module.exports = __webpack_public_path__ + "static/img/f3ec69c.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/title.png
// module id = 648
// module chunks = 2